<template>
  <div class="side_menu_area">
    <div class="search_word_area" :class="searchWordAreaClass" v-if="enableSearch">
      <span class="blind">{{ $t('gnb.search') }}</span>
      <form>
        <div class="sizing_wrap">
          <label for="inp_search" class="btn_search" @click="showSearchInput">{{ $t('gnb.enter_keyword') }}</label>
          <!-- [D]btn_search 클릭시 search_word_area에 is_active 클래스 추가 -->
          <input type="text" @keydown.enter.prevent="search" id="inp_search" class="inp_search" :value="searchInput.value" :placeholder="$t('gnb.enter_keyword')"
            @focusout="hideSearchInput(false)" autocomplete="off" @input="updateSearchInputValue">
          <button type="reset" class="btn_search_reset" v-if="isAvailableRestSearchInput" @click="hideSearchInput(true)">✕</button>
          <!-- [D] inp_search에 값이 있을때만 노출 -->
        </div>
      </form>
    </div>
    <div class="lang_select_area" v-if="enableChangeLocale" @mouseover="hoverMenu('locale', true)" @mouseout="hoverMenu('locale', false)">
      <span class="blind">{{ $t('gnb.select_lang') }}</span>
      <button class="btn_select_lang" @mouseover="hoverMenu('locale', true)">
        <span class="blind">{{ $t('gnb.selected_lang') }}</span>
        <span class="select_lang_txt">{{userLocale.displayName}}</span>
      </button>
      <!-- [D]선택한 btn_lang의 value를 select_lang_txt의 value에 적용 -->
      <ul v-if="hover.menus.locale" class="lst_lang is_show" @mouseover="hoverMenu('locale', true)" @mouseout="hoverMenu('locale', false)">
        <li class="lang_item" :class="{ 'is_selected': userLocale.code == locale.code }" v-for="locale in locales" :key="locale.code">
          <a @click.prevent="changeLocale(locale)" class="btn_lang">{{ locale.displayName }}</a>
        </li>
      </ul>
    </div>
    <a :href="newsletterUrl" v-if="enableNewsletter" class="link_newsletter" target="_blank">{{$t('gnb.newsletter')}}</a>
    <!-- [D] 로그인 전 노출 영역 -->
    <ul class="lst_member_link" v-if="enableUserMenu && isEmpty(session.uuid)">
      <li class="link_item">
        <a :href="getToastIdUrl('login')" class="link_txt">{{ $t('gnb.signin') }}</a>
      </li>
      <li class="link_item" v-if="joinButton.show != false">
        <a :href="isEmpty(joinButton.url) ? getToastIdUrl('join') : `${this.getDomain('toastId')}${joinButton.url}`" class="link_txt">
          {{ $t('gnb.join') }}
        </a>
      </li>
    </ul>
    <!-- [D] 로그인 후 노출 영역 -->
    <div class="member_setting_area" v-if="enableUserMenu && exist(session.uuid)" @mouseover="hoverMenu('session', true)" @mouseout="hoverMenu('session', false)">
      <a href="javascript:;" class="btn_member_setting">{{session.maskedEmail}}</a>
      <ul v-show="hover.menus.session" class="lst_member_setting is_show" @mouseout="hoverMenu('session', false)">
        <!-- [D] btn_member_setting에 마우스 오버시 lst_member_setting에 is_show 클래스 추가 -->
        <li class="setting_item">
          <a :href="this.memberInfoUrl" class="link_txt" :target="isDefaultSetting ? '_self' : '_blank'">{{
            $t('gnb.profile') }}</a>
        </li>
        <li v-if="envs.account.loginSecurity.enabled" class="setting_item">
          <a :href="this.memberLoginSecurityUrl" class="link_txt" :target="isDefaultSetting ? '_self' : '_blank'">{{
              $t('gnb.login-security') }}</a>
        </li>
        <li v-if="marketplaceEnabled" class="setting_item">
          <router-link-ex :to="`${countryPath}/account/marketplace`" class="link_txt" :domain="getDomain('homepage')">
            <span class="menu_txt">{{ $t('gnb.marketplace.title') }}</span>
          </router-link-ex>
        </li>
        <li v-if="envs.edu.enabled && !this.isJp" class="setting_item">
          <router-link-ex :to="`${countryPath}/account/edu`" class="link_txt" :domain="getDomain('homepage')">
            <span class="menu_txt">{{ $t('gnb.edu.title') }}</span>
          </router-link-ex>
        </li>
        <li class="setting_item">
          <router-link-ex :to="`${countryPath}/account/payment`" class="link_txt" :domain="getDomain('homepage')">
            <span class="menu_txt">{{ $t('gnb.payment_info') }}</span>
          </router-link-ex>
        </li>
        <li class="setting_item">
          <router-link-ex :to="`${countryPath}/account/credit`" class="link_txt" :domain="getDomain('homepage')">
            <span class="menu_txt">{{ $t('gnb.credit') }}</span>
          </router-link-ex>
        </li>
        <li class="setting_item">
          <router-link-ex :to="`${countryPath}/account/terms`" class="link_txt" :domain="getDomain('homepage')">
            <span class="menu_txt">{{ $t('gnb.mypage.terms') }}</span>
          </router-link-ex>
        </li>
        <li class="setting_item has_top_line">
          <a :href="`${getDomain('console')}/billing`" class="link_txt" target="_blank">{{ $t('gnb.billing') }}</a>
        </li>
        <li class="setting_item has_top_line">
          <a :href="getToastIdUrl('logout')" class="link_txt">{{ $t('gnb.signout') }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'

import { namespace as sessionNamespace, types as sessionTypes } from '../../../store/modules/session-store'
import { namespace as gnbNamespace, types as gnbTypes } from '../../../store/modules/gnb-store'
import envs from '@/common/envs'

import GnbHeaderCommon from './GnbHeaderCommon'

export default {
  mixins: [GnbHeaderCommon],
  props: {
    isDefaultSetting: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: true
    },
    enableChangeLocale: {
      type: Boolean,
      default: true
    },
    enableUserMenu: {
      type: Boolean,
      default: true
    },
    joinButton: {
      type: Object,
      default: () => {
        return {
          show: true,
          url: ''
        }
      }
    },
    enableNewsletter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      memberInfoUrl: `${this.getDomain('toastId')}${envs.common.member.information}`,
      memberLoginSecurityUrl: `${this.getDomain('toastId')}` + '/members/login-security',
      envs: envs,
      marketplaceEnabled: envs.marketplace.header.enabled
    }
  },
  watch: {
    $route: function() {
      if (this.$route.path.indexOf('/search') < 0) {
        this.hideSearchInput(true)
      }
    }
  },
  methods: {
    ...mapMutations(sessionNamespace, [sessionTypes.SET_USER_LOCALE]),
    ...mapMutations(gnbNamespace, [gnbTypes.SET_SEARCH_INPUT_ACTIVATION, gnbTypes.SET_SEARCH_INPUT_VALUE]),
    search() {
      if (this.mode == 'homepage') {
        this.$router.push({
          path: `${this.countryPath}/search/all`,
          query: { q: this.searchInput.value }
        })
      } else {
        location.href = `${this.getDomain('homepage')}${this.countryPath}/search/all?q=${this.searchInput.value}`
      }
    },
    showSearchInput() {
      if (this.searchInput.active) {
        this.search()
      } else {
        this.setSearchInputActivation(true)
      }
    },
    hideSearchInput(force) {
      if (force) {
        this.setSearchInputValue('')
      }

      if (this.searchInput.value === '') {
        this.setSearchInputActivation(false)
      }
    },
    updateSearchInputValue(e) {
      this.setSearchInputValue(e.target.value)
    },
    changeLocale(locale) {
      if (this.canUseRoute) {
        this.setUserLocale(locale.code)
        this.$i18n.locale = locale.lang
        this.hoverMenu('locale', false)
      } else {
        window.$cookies.set('userLocale', locale.code, -1, '/', envs.cookie.domain)
        location.reload()
      }
    }
  },
  computed: {
    ...mapState(sessionNamespace, ['session', 'mode', 'userLocale', 'locales']),
    ...mapState(gnbNamespace, ['searchInput', 'hover']),
    ...mapGetters(gnbNamespace, [gnbTypes.SEARCH_WORD_AREA_CLASS, gnbTypes.IS_AVAILABLE_RESET_SEARCH_INPUT]),
    newsletterUrl() {
      return  this.getDomain('newsletter')
    }
  },

}
</script>
